import { Injectable } from "@angular/core";
import * as DetectRtc from "src/assets/js-library/DetectRTC-master/DetectRTC.js";
import { LoggerService } from "../../ui/logger/logger.service";
import { CONNECTION_TYPES, supportedBrowsers } from "src/app/_constants/app.constants";
import { AppModule } from "src/app/app.module";
import { ServiceModule } from 'src/app/_services/service.module';

// declare var DetectRtc: any;

@Injectable({
  providedIn: ServiceModule,
})
export class RtcService {

  browser: any
  permissionsRequested: boolean = false

  constructor(private logger: LoggerService) { }

  async requestPermissions(permissionName: string): Promise<any> {
    const cameraPermissionName = "camera" as PermissionName
    const microphonePermissionName = "microphone" as PermissionName
    const permissionDescriptor: PermissionDescriptor = {
      name: permissionName === 'camera' ? cameraPermissionName : microphonePermissionName
    }
    let permissionStatus: any = await navigator.permissions.query(permissionDescriptor).catch(e => e)
    if (permissionStatus.state === 'prompt') {
      let mediaStreamConstraints: MediaStreamConstraints = {
        video: permissionName === 'camera',
        audio: permissionName === 'microphone'
      }
      await navigator.mediaDevices.getUserMedia(mediaStreamConstraints).catch(e => e)
      this.permissionsRequested = true
      permissionStatus = await navigator.permissions.query(permissionDescriptor).catch(e => e)
    }
    return permissionStatus
  }

  async getConnectionTypes(): Promise<string[]> {
    return new Promise(async (resolve, reject) => {
      try {
        const query = ['microphone', 'camera'] as any;
        const availableContactOptions = ['text'];
  
        for (let i of query) {
          const permission = await navigator.permissions.query({ name: i });
          if (permission.name === 'audio_capture' && permission.state !== 'denied') {
            availableContactOptions.push('audio');
          }
          if (permission.name === 'video_capture' && permission.state !== 'denied') {
            availableContactOptions.push('video');
          }
        }

        resolve(availableContactOptions);
      } catch (e) {
        resolve(['text']);
      }
    })
  }

  isBrowserSupported() {
    const currentBrowser = DetectRtc.browser;
    this.browser = currentBrowser
    let isBrowserSupported = supportedBrowsers.some(browser => {
      return browser.name === currentBrowser.name;
    });
    return isBrowserSupported;
  }

  async isCameraAvailable(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      DetectRtc.load(() => {
        this.logger.debug("RtcService.isCameraAvailable", DetectRtc)
        resolve(DetectRtc.hasWebcam);
      });
    });
  }

  //returns the current OS.
  getOSName(): string {
    return DetectRtc.osName;
  }

  //returns if the current device is mobile
  isMobileDevice() {
    return DetectRtc.isMobileDevice;
  }
}
